// extracted by mini-css-extract-plugin
module.exports =  {"BestsellerPagination":"BestsellerPagination__PGRni"};